import { alertService } from 'components/Varios/alert_service';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import React, { useCallback, useState, useMemo } from 'react';
import { useTable, Column, Accessor, HeaderGroup, useGlobalFilter, usePagination, useSortBy, useRowSelect } from "react-table";
import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';

import ExitoSVG from "assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"

import {
    AprobarParcialmenteSolicitudPermisos, DirectivoAprobadorObtenerVistaPreviaFormularioPermisos,
    AprobarSolicitudPermisos,
    AprobarMasivaSolicitudPermisos,
    RechazarSolicitudPermisos
} from './FunctionsAprobacionSolicitudes';

import { EstadoSolicitudReplanificacionVacaciones, EstadoSolicitud, TipoFiltroSolicitudAprobar, TipoSolicitud, EstadoSolicitudPermisos, TipoSolicitudPermiso } from './TypesAprobacionSolicitudes';

import ModalRechazo from "./ModalRechazoSolicitud"

import { Checkbox } from 'components/Varios/Tabla/CheckBoxTable';
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

import ButtonAprobarMasivo from 'components/Varios/ButtonAprobarMasivo';
import { ReactComponent as Aprobar } from "assets/icons/Check.svg"
import { ReactComponent as Negar } from "assets/icons/X.svg"

import Swal from 'sweetalert2'

import "../../../assets/scss/TablaAprobacionSolicitudesMasivas.scss";

export default function TableSolicitudesPermisosAprobar({ dataprops, recargarInformacionTabla, tipoFiltroSolicitud, onClickVerDocumento, filtrarTiposSolicitud }) {
  

    
    const TIPO_SOLICITUDES_APROBAR_MASIVAMENTE = [TipoSolicitudPermiso.PERMISOSAM, TipoSolicitudPermiso.PERMISOSMH, TipoSolicitudPermiso.LICENCIASCD, TipoSolicitudPermiso.LICENCIASM, TipoSolicitudPermiso.LICENCIASP, TipoSolicitudPermiso.LICENCIASEFP]

    const defaultStateInformacionModalAprobarPermisos = {
        url: "",
        cargando: false,
        idPermiso: -1,
        modalContent: undefined,
        tituloModal: "Solicitud Permisos"
    }

    const defaultStateInformacionModalAprobarParcialmentePermisos = {
        tituloModal: "Aprobación Parcial Solicitud de Permisos",
        cargando: false,
        idPermiso: -1,
        contentBody: undefined
    }


    const defaultStateInformacionModalRechazarPermisos = {

        cargando: false,
        idPermiso: -1,
        contentBody: undefined,
        observacion: ""
    }

    const defaultSateModalAprobacionMasivaSolicitudPermisos = {
        cargando: false,
        listadoSolicitudesAprobar: [],
        contentBody: undefined
    }




    const [stateinformacionModalAprobarPermisos, setstateinformacionModalAprobarPermisos] = useState(defaultStateInformacionModalAprobarPermisos)
    const [stateinformacionModalAprobarParcialmentePermisos, setstateinformacionModalAprobarParcialmentePermisos] = useState(defaultStateInformacionModalAprobarParcialmentePermisos)
    const [stateinformacionModalRechazarPermisos, setstateinformacionModalRechazarPermisos] = useState(defaultStateInformacionModalRechazarPermisos)

    //Aprobacion Masiva
    const [stateModalAprobacionMasivaSolicitudPermisos, setstateModalAprobacionMasivaSolicitudPermisos] = useState(defaultSateModalAprobacionMasivaSolicitudPermisos)

    const [observacion, setobservacion] = useState("")
    const data = React.useMemo(
        () => [...dataprops], [dataprops]
    )

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }


    const GenerarCellDocumentos = (data) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            {data.documentos.refArchivo1 && (
                <i
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Evidencia"
                    onClick={() => onClickVerDocumento(data.documentos.refArchivo1)}
                >
                    <img
                        src={PdfSVG}
                        className="acciones"
                        alt="Vista Previa Evidencia"
                        style={{ width: 24, height: 24 }}
                    />
                </i>
            )}
        </div>
    );


    async function OnClickAccionModalFormulario(idPermiso) {
        setstateinformacionModalAprobarPermisos({ cargando: true })
        var accionRealizada = await AprobarSolicitudPermisos(idPermiso)
        setstateinformacionModalAprobarPermisos(defaultStateInformacionModalAprobarPermisos)
        await recargarInformacionTabla();
    }

    async function onClickAprobarSolicitudPermisos(informacionAcciones) {
        setstateinformacionModalAprobarPermisos({ ...defaultStateInformacionModalAprobarPermisos, cargando: true })

        var respuesta = await DirectivoAprobadorObtenerVistaPreviaFormularioPermisos(informacionAcciones.idPermiso);



        if (respuesta.status === 200) {

            const tituloModal = informacionAcciones.tipoPermiso;

            setstateinformacionModalAprobarPermisos({
                url: respuesta.dataResponse,
                cargando: false,
                idPermiso: informacionAcciones.idPermiso,
                modalContent: AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones),
                tituloModal

            })
        }
        else {
            setstateinformacionModalAprobarPermisos(defaultStateInformacionModalAprobarPermisos)
            //alertService.error(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud de Permisos y/o Licencias");
            showAlert(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud de Permisos y/o Licencias", ErrorSVG, false)
        }
    }


    function onClickAprobarParcialmenteSolicitudPermisos(informacionAcciones) {

        const contentBody = AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones);
        const tituloModal = "Aprobación Parcial Solicitud de "+informacionAcciones.tipoPermiso
        setstateinformacionModalAprobarParcialmentePermisos({
            cargando: false,
            idPermiso: informacionAcciones.idPermiso,
            contentBody,
            tituloModal: tituloModal
        })
    }


    function onClickRechazarSolicitudPermisos(informacionAcciones) {

        const contentBody = AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones);

        setstateinformacionModalRechazarPermisos({
            cargando: false,
            idPermiso: informacionAcciones.idPermiso,
            contentBody,
            observacion

        })
    }



    async function RechazarPermisos(idSolicitud, observacion) {
        const respuesta = await RechazarSolicitudPermisos(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            showAlert(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud de Permisos y/o Licencias", ErrorSVG, false);
        }
        else {
            //alertService.success("Se ha negado la solicitud de permiso y/o licencia");
            showAlert("Se ha negado la solicitud de permiso y/o licencia", ExitoSVG, true);
        }
    }




    function onClickAprobacionMasiva(solicitudesPermisosAprobar) {

        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>

                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Estado</th>
                            <th> Días </th>
                            <th> Horas </th>

                        </tr>
                    </thead>
                    <tbody>

                        {solicitudesPermisosAprobar.map((solicitudes, ind) => {
                            const informacionAcciones = solicitudes.acciones;
                            return (
                                <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.nombres}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                        </div>

                                    </td>

                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.estadoParse}
                                        </div>

                                    </td>


                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.tiempo}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.horasDif}
                                        </div>

                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </Table>
            </>

        )

        setstateModalAprobacionMasivaSolicitudPermisos({
            cargando: false,
            listadoSolicitudesAprobar: solicitudesPermisosAprobar,
            contentBody


        })
    }



    const ModalAprobacionMasivaSolicitudVacaciones = useMemo(() => {
        return (
            <ModalConfirmacion
                show={stateModalAprobacionMasivaSolicitudPermisos.listadoSolicitudesAprobar.length > 0}
                size="lg"
                onClose={() => setstateModalAprobacionMasivaSolicitudPermisos(defaultSateModalAprobacionMasivaSolicitudPermisos)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar las siguientes solicitudes"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarMasivaSolicitudPermisos(stateModalAprobacionMasivaSolicitudPermisos.listadoSolicitudesAprobar)}
                contentModal={stateModalAprobacionMasivaSolicitudPermisos.contentBody}
                tituloModal={"Aprobación masiva solicitudes"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}

            />


        )
    }, [stateModalAprobacionMasivaSolicitudPermisos])


    function AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones) {

        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Hora Desde </th>
                            <th> Hora Hasta </th>
                            <th> Días </th>
                            <th> Horas </th>
                            <th> Estado</th>
                            

                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.horaInicio}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.horaFin}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tiempo}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.horasDif}
                                </div>
                            </td>


                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </Table>
            </>

        )

        return contentBody;
    }

    

    const GenerarCellAcciones = (informacionAcciones) => {
        if (!informacionAcciones) return <span></span>;
    
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                {(informacionAcciones.estadoPermiso === EstadoSolicitudPermisos.INGRESADO ||
                    informacionAcciones.estadoPermiso === EstadoSolicitudPermisos.REVISADOPARCIAL) &&
                informacionAcciones.aprueba === "S" ? (
                    <>
                    <Aprobar
                        onClick={() => onClickAprobarSolicitudPermisos(informacionAcciones)}
                        data-toggle="tooltip" data-placement="top" title="Aprobar"
                        className={"acciones"}
                    />
                    <Negar
                        onClick={() => onClickRechazarSolicitudPermisos(informacionAcciones)}
                        data-toggle="tooltip" data-placement="top" title="Negar"
                        className={"acciones"}
                    />

                        {/* <i
                            className="fa-regular fa-circle-check acciones"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Aprobar"
                            onClick={() => onClickAprobarSolicitudPermisos(informacionAcciones)}
                        />
                        <i
                            className="fa-regular fa-circle-xmark ml-2 acciones"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Negar"
                            onClick={() => onClickRechazarSolicitudPermisos(informacionAcciones)}
                        /> */}
                    </>
                ) : (informacionAcciones.estadoPermiso === EstadoSolicitudPermisos.INGRESADO && informacionAcciones.aprueba === "N") ? (
                    <>
                        <Aprobar
                            onClick={() => onClickAprobarParcialmenteSolicitudPermisos(informacionAcciones)}
                            data-toggle="tooltip" data-placement="top" title="Aprobar"
                            className={"acciones"}
                        />
                        <Negar
                            onClick={() => onClickRechazarSolicitudPermisos(informacionAcciones)}
                            data-toggle="tooltip" data-placement="top" title="Negar"
                            className={"acciones"}
                        />
                        {/* <i
                            className="fa-regular fa-circle-check acciones"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Aprobar"
                            onClick={() => onClickAprobarParcialmenteSolicitudPermisos(informacionAcciones)}
                        />
                        <i
                            className="fa-regular fa-circle-xmark ml-2 acciones"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Negar"
                            onClick={() => onClickRechazarSolicitudPermisos(informacionAcciones)}
                        /> */}
                    </>
                ) : null}
            </div>
        );
    };

    const column_usando = React.useMemo(
        () => [
            {
                Header: "Tipo de Solicitud",
                accessor: "tipoPermiso"
            },
            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Nombres',
                accessor: 'nombres',
            },
            {
                Header: 'Fecha Desde',
                accessor: 'fechaInicio',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Fecha Hasta',
                accessor: 'fechaFin',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Hora Desde',
                accessor: 'horaInicio',
                
            },
            {
                Header: 'Hora Hasta',
                accessor: 'horaFin',
                
            },
            {
                Header: 'Horas',
                accessor: 'horasDif',
                
            },
            {
                Header: 'Días',
                accessor: 'tiempo',
            },
            {
                Header: 'Estado',
                accessor: 'estadoParse',
            },
            {
                Header: 'Observaciones',
                accessor: 'observacion',
            },
            {
                Header: "Documentos",
                accessor: (row) => ({
                    documentos: row,
                }),
                Cell: ({ value }) => GenerarCellDocumentos(value),
                style: { textAlign: 'center' },
            },
            {
                Header: "Acciones",
                accessor: 'acciones',
                Cell: ({ value }) => GenerarCellAcciones(value)
            }
        ], [dataprops]
    )




    function ShowCheckBoxCondition(dataRow) {
        return dataRow && TIPO_SOLICITUDES_APROBAR_MASIVAMENTE.includes(dataRow.acciones.idTipoPermiso);
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        prepareRow,
        state,
        setGlobalFilter,
        getToggleHideAllColumnsProps,
        getToggleAllPageRowsSelectedProps,
        toggleRowSelected

    } = useTable(
        {
            columns: column_usando,
            data
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [

                    ...columns,
                    {
                        id: 'selection',
                        Header: ({ getToggleAllPageRowsSelectedProps }) => (
                            <Checkbox
                                isHeader={true}
                                {...getToggleAllPageRowsSelectedProps()}
                            />
                        ),
                        Cell: ({ row }) => (
                            <Checkbox
                                condition={ShowCheckBoxCondition(row.values)}
                                {...row.getToggleRowSelectedProps()}

                            />
                        )

                    }
                ]
            })
        }
    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = data.length;

    const columnasStyles = (cell) => [
        {
            HeaderName: "Documentos",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Acciones',
            StyleHeader: {
                textAlign: "center"
            }
        },
    ]

    const ButtonAprobacionMasiva = useMemo(() => {

        const nombreBotonAprobarMasivo = "Aprobar todas las solicitudes seleccionadas";
        if (selectedFlatRows.length === 1) {
            var filaSeleccionada = selectedFlatRows[0].original;
            if (TIPO_SOLICITUDES_APROBAR_MASIVAMENTE.includes(filaSeleccionada.idTipoPermiso)) {

                if (filaSeleccionada.aprueba === "S") {
                    return <ButtonAprobarMasivo
                        onClick={() => onClickAprobarSolicitudPermisos(filaSeleccionada.acciones)}
                        text="Aprobar Solicitud"
                    />
                    //return <ButtonAprobarMasivo className="fleft" onClick={() => onClickAprobarSolicitudPermisos(filaSeleccionada.acciones)} >Aprobar Solicitud </ButtonAprobarMasivo>
                }
                else {
                    return <ButtonAprobarMasivo
                        onClick={() => onClickAprobarParcialmenteSolicitudPermisos(filaSeleccionada.acciones)}
                        text="Aprobar Solicitud"
                    />
                    //return <ButtonAprobarMasivo className="fleft" onClick={() => onClickAprobarParcialmenteSolicitudPermisos(filaSeleccionada.acciones)} >Aprobar Solicitud </ButtonAprobarMasivo>
                }

            }
            else {
                return <ButtonAprobarMasivo
                        disabled
                        text="Aprobar Solicitud"
                    />
                //return <ButtonAprobarMasivo className="fleft" disabled>Aprobar Solicitud </ButtonAprobarMasivo>
            }
        }

        else if (selectedFlatRows.length > 1) {
            var filasSeleccionadas = selectedFlatRows;
            var filasMapeadas = [];
            filasSeleccionadas.forEach(element => {
                if (TIPO_SOLICITUDES_APROBAR_MASIVAMENTE.includes(element.original.idTipoPermiso)) {
                    filasMapeadas.push(element.original)
                }
            });
            if (filasMapeadas.length > 0) {
                return <ButtonAprobarMasivo
                    onClick={() => onClickAprobacionMasiva(filasMapeadas)}
                    text={nombreBotonAprobarMasivo}
                />
                // return (<Button className="fleft" onClick={() => onClickAprobacionMasiva(filasMapeadas)} >{nombreBotonAprobarMasivo} </Button>)
            }
            else if (filasMapeadas.length <= 0) {
                return <ButtonAprobarMasivo
                    text={nombreBotonAprobarMasivo}
                    disabled={true}
                />
                // return (<Button className="fleft" disabled >{nombreBotonAprobarMasivo} </Button>)
            }
        }
        else {
            return <ButtonAprobarMasivo
                text={nombreBotonAprobarMasivo}
                disabled={true}
            />
            // return <Button className="fleft" disabled>{nombreBotonAprobarMasivo}</Button>
        }

    }, [selectedFlatRows])


    

    return (
        <React.Fragment>
            {/* <Row>
                <Col xl={12}>
                    <GlobalFilterTable
                        filter={globalFilter}
                        setFilter={setGlobalFilter}
                    />
                </Col>
            </Row>
            <Row className={"mb-3 rowBotonFiltroAprobacionMasivaSolicitudes"}>


                <Col xl={2}>
                    <div className='containerBotonAprobMasivaSolicitudes'>
                        {ButtonAprobacionMasiva}
                    </div>
                </Col>
            </Row> */}

            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />
                        {/* <div className='containerBotonAprobMasivaSolicitudes'> */}
                        {ButtonAprobacionMasiva}
                    </div>


                </Col>
            </Row>

            <Row className={"mb-2"}>

                <Col>
                    <p>{tipoFiltroSolicitud === TipoFiltroSolicitudAprobar.PERMISOS ? "Se estan mostrando las solicitudes de permisos y licencias" : ""}</p>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            style={{ width: column.Header === "Observaciones" ? "300px" : "auto" }}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}

                    />
                </Col>
            </Row>



            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalAprobarPermisos.url !== "" || stateinformacionModalAprobarPermisos.cargando}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalAprobarPermisos.cargando}
                onClose={() => setstateinformacionModalAprobarPermisos(defaultStateInformacionModalAprobarPermisos)}
                size="xl"
                tituloModal={stateinformacionModalAprobarPermisos.tituloModal}
                urlArchivo={stateinformacionModalAprobarPermisos.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalAprobarPermisos.idPermiso)}
                nombreBotonAccion={"Aprobar"}
                disabledbuttonCondition={stateinformacionModalAprobarPermisos.cargando}
                modalContent={undefined}
                asyncClose={true}

            />

            {/* Aprobacion Parcial de permisos */}
            <ModalConfirmacion
                show={stateinformacionModalAprobarParcialmentePermisos.idPermiso > 0 || stateinformacionModalAprobarParcialmentePermisos.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAprobarParcialmentePermisos(defaultStateInformacionModalAprobarParcialmentePermisos)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud de permiso?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarParcialmenteSolicitudPermisos(stateinformacionModalAprobarParcialmentePermisos.idPermiso)}
                contentModal={stateinformacionModalAprobarParcialmentePermisos.contentBody}
                tituloModal={stateinformacionModalAprobarParcialmentePermisos.tituloModal}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}


            />

            <ModalRechazo
                show={stateinformacionModalRechazarPermisos.idPermiso > 0 || stateinformacionModalRechazarPermisos.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazarPermisos(defaultStateInformacionModalRechazarPermisos)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de permiso y/o licencia?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarPermisos(stateinformacionModalRechazarPermisos.idPermiso, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarPermisos.contentBody}
                tituloModal={"Negar Solicitud de Permisos y/o Licencias"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            />

            {ModalAprobacionMasivaSolicitudVacaciones}

        </React.Fragment>
    )


}
